module.exports = __webpack_public_path__ + "themes/fq/sprite/sas-small-reduced.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/sas-small-reduced.png
// module id = 73
// module chunks = d-game